// extracted by mini-css-extract-plugin
module.exports = {"c1axdy7y":"c1axdy7y","t1f8ue4o":"t1f8ue4o","i6t8yrg":"i6t8yrg","ffa96yr":"ffa96yr"};